import React from 'react';
import { ModuleBridge } from '../components';

export const ReportingDrReplications = () => {
    return <ModuleBridge moduleId="reporting_dr_replications_module" />;
};
